import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'

export const EloquaCampaignSchema = buildEntrySchemaFor('eloquaCampaign', {
  fields: z.lazy(() =>
    z.object({
      elqFormName: z.string(),
    }),
  ),
})

export type EloquaCampaign = z.infer<typeof EloquaCampaignSchema>

export const isEloquaCampaign = (campaign: unknown): campaign is EloquaCampaign => {
  return EloquaCampaignSchema.safeParse(campaign).success
}
